module.exports = Foundation;


/*****************
 ** WEBPACK FOOTER
 ** external "Foundation"
 ** module id = 5
 ** module chunks = 0
 **/